import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const User: React.FC<IconProps> = ({
  className = '',
  fill = colors.blueGrey,
  d = 'M12 4a4 4 0 0 1-8 0 4.08 4.08 0 0 1 4-4 4 4 0 0 1 4 4zM8 9c-4.7 0-8 2.5-8 6v1h16v-1c0-3.5-3.3-6-8-6z',
  viewBox = '0 0 16 16',
  transition = 'fill 0.1s ease-in-out',
  cssHelper = Styling.fullHeightStyle,
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      viewBox={viewBox}
      cssHelper={cssHelper}
      role='img'
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Path fill={fill} d={d} transition={transition} />
    </Elements.Svg>
  );
};

export default User;
